<template>
  <div>
    <v-dialog v-model="show" @click:outside="closeDialog">

      <v-card>
        <v-card-title>
          <v-progress-linear indeterminate color="teal" v-if="loading"></v-progress-linear>

          <strong>{{ $t('views.dialogOrderDetail.title') }} |</strong>&nbsp;#{{ paymentOrderId }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <!-- BASIC DATA ITERATOR FOR PAYMENT ORDER INFO -->
            <v-col cols="6">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.ddpgOrderId') }}</td>
                      <td>{{ order.payment_order_id }}</td>
                    </tr>
                    <tr v-if="order.organization_name"><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.organization') }}</td>
                      <td>{{ order.organization_name }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.merchant') }}</td>
                      <td>{{ order.merchant_name }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.ddpayOrderId') }}</td>
                      <td>{{ order.merchant_order_number }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.amount') }}</td>
                      <td>{{ order.currency }}${{ Number(order.amount).toLocaleString() }}</td>
                    </tr>
                    <!-- <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.paidVia') }}</td>
                      <td>{{ order.payment_type }}</td>
                    </tr> -->
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.status') }}</td>
                      <td>{{ order.status }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.createdAt') }}</td>
                      <td>{{ order.created_at }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <!-- MORE DATA ITERATOR FOR PAYMENT ORDER INFO -->
            <v-col cols="6">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.paymentService') }}</td>
                      <td>
                        <div v-if="getPaymentServiceIcon(order.payment_service)">
                          <img :src="getPaymentServiceIcon(order.payment_service)" style="height: 28px;">
                        </div>
                        <div v-else>{{ order.payment_service }}</div>
                      </td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.paymentType') }}</td>
                      <td>
                        <div v-if="getPaymentServiceIcon(order.payment_service_type)">
                          <img :src="getPaymentServiceIcon(order.payment_service_type)" style="height: 28px;">
                        </div>
                        <div v-else>{{ order.payment_service_type }}</div>
                      </td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.paymentServiceName') }}</td>
                      <td>{{ order.payment_service_name }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.useTds') }}</td>
                      <td>{{ order.use_tds == 1? 'Yes': 'No' }}</td>
                    </tr>
                    <tr v-if="user.level === 'superadmin'"><td class="font-weight-medium">Request Context (for debug)</td>
                      <td>
                        <a @click="showRequestContext = true" v-if="!showRequestContext">Show</a>
                        <span v-if="showRequestContext">{{ order.request_context }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <br/>
              <div>
                <!-- 之後可以看要不要擋訂單狀態 -->
                <v-btn rounded depressed small color="blue" class="ml-1"
                    :disabled="order.status !=='completed'"
                    @click="openDisputeDialog()">
                    <v-icon left>mdi-receipt-text-plus-outline</v-icon>
                    新增負項訂單
                </v-btn>
              </div>
            </v-col>

            <!-- LIST OF TRANSACTIONAL HISTORY -->
            <v-col cols="12">
              <h4 class="text-center">{{ $t('views.dialogOrderDetail.transactionalHistory') }}</h4>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th v-for="col in transactionSchema" :key="col.value">
                        {{ col.text }}
                      </th>
                      <th>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="t in transactions" :key="t['id']">
                      <td v-for="col in transactionSchema" :key="col.value">
                        {{ t[col.value] }}
                      </td>
                      <td width="20%">
                        <v-btn fab x-small color="info" @click="showTransactionDetail(t)">
                          <v-icon>mdi-information</v-icon>
                        </v-btn>
                        <v-btn v-if="['paid', 'captured'].indexOf(t['status']) >= 0"
                          rounded small color="error" class="ml-2" @click="requestRefund(t)">
                          <v-icon left>mdi-cash-refund</v-icon>
                          {{ $t('views.dialogOrderDetail.refund') }}
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <!-- EXPANSION - TRANSACTION CONTEXT -->
              <v-expand-transition>
                <v-card outlined v-show="expansion.detail.show" class="ma-2 pa-2">
                  <v-card-text>
                    {{ JSON.stringify(expansion.detail.context, null, 2) }}
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text @click="expansion.detail.show = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expand-transition>
            </v-col>

          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 負項訂單 -->
    <v-dialog
        v-model="dialog.dispute.show"
        width="500px"
      >
        <v-card>
          <v-card-title>
            新增負項訂單
            
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <label>實際負項訂單金額會扣除原手續費</label>
            </v-row>
            <v-row >
              <v-col>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.ddpgOrderId') }}</td>
                        <td>
                          {{ dialog.dispute.model.paymentOrderId }}
                        </td>
                      </tr>
                      <tr><td class="font-weight-medium">MID</td>
                        <td>
                          {{ dialog.dispute.model.merchantId }}
                        </td>
                      </tr>
                      <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.amount') }}</td>
                        <td>{{ order.currency }}${{ Number(dialog.dispute.model.amount).toLocaleString() }}</td>
                      </tr>
                      <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.reason') }}</td>
                        <td>
                          <v-text-field v-model="dialog.dispute.model.reason"></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-btn
                variant="text"
                @click="closeDisputeDialog"
              >
                {{ $t('views.dialogOrderDetail.cancelButton') }}
              </v-btn>
              <v-btn
                color="warning"
                variant="text"
                @click="addDispute"
              >
              {{ $t('views.dialogOrderDetail.confirmButton') }}
              </v-btn>
            </v-row>
          </v-card-text>
          <v-card-actions>
            
          </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { GetIconMixin } from '@/mixins/get-icons';
import axios from 'axios';

export default {
  name: 'CardpayOrderDetailDialog',
  props: {
    show: Boolean,
    paymentOrderId: String
  },
  mixins: [
    GetIconMixin
  ],

  mounted() {

  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    fetchPaymentOrderInfo() {
      this.showRequestContext = false;
      this.loading = true;
      axios.get(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/orders/${this.paymentOrderId}`
        + `?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
      )
      .then(response => {
        this.order = response.data;
      })
      .catch(err => {
        console.error(`Failed to fetch payment order information.`, err.response);
        this.$notify({
          text: `Failed to fetch payment order information.`,
          type: 'error', 
        });
        this.order = {};
      })
      .finally(() => {
        this.loading = false;
      });
    },
    fetchTransactionHistory() {
      axios.get(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/orders/${this.paymentOrderId}/history`
        + `?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
      )
      .then(response => {
        this.transactions = response.data;
      })
      .catch(err => {
        console.error(`Failed to fetch transactional history.`, err.response);
        this.$notify({
          text: `Failed to fetch transactional history.`,
          type: 'error', 
        });
        this.transactions = [];
      });
    },

    showTransactionDetail(_transaction) {
      this.expansion.detail.context = _transaction['context'];
      this.expansion.detail.show = true;
    },

    requestRefund() {
      if (!confirm(`Sure you want to refund for $${this.order['amount']}? This cannot be undone.`))
        return;

      axios.delete(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/orders/${this.paymentOrderId}/refund`,
        {
          data: { "userId": this.user['id'] }//Who request this refund?
        }
      )
      .then(response => {
        this.$notify({
          text: `Refund has been requested (order ${this.paymentOrderId}). It will be processed in a while.`,
          type: 'warn'
        });
        //FIXME: Refresh the transactional history after 3 seconds.
        setTimeout(() => {
          this.fetchTransactionHistory();
        }, 3000);
      })
      .catch(err => {
        this.$notify({
          text: `Cannot request for refund (order ${this.paymentOrderId}). `
            + `The banking system may be still processing the transaction, please try again some time later.`,
          type: 'error', duration: 10000
        });
      });
    },

    openDisputeDialog () {
      this.dialog.dispute.model.paymentOrderId = this.order.payment_order_id;
      this.dialog.dispute.model.merchantId = this.order.merchant_id;
      this.dialog.dispute.model.amount = this.order.amount;
      this.dialog.dispute.model.reason = '爭議款';
      this.dialog.dispute.show = true;
    },

    closeDisputeDialog () {
      this.dialog.dispute.model.paymentOrderId = '';
      this.dialog.dispute.model.merchantId = '';
      this.dialog.dispute.model.amount = 0; 
      this.dialog.dispute.show = false;
    },

    addDispute () {
      this.$swal({
        text: '是否確認要新增負項訂單？',
        icon: 'warning',
        confirmButtonText: 'Yes!',
        showCloseButton: true
      })
      .then(result => {
        if (!result.isConfirmed) return;
        const data = this.dialog.dispute.model;
        data.userId = this.user.id;
        if (data.reason && data.reason.length) {
          data.reason = data.reason.trim();
        } else {
          data.reason = '爭議款';
        }
        console.log('data:', data, this.user)
        
        axios.post(`${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/ledger-surcharges`, data)
        .then(response => {
          this.$notify({
            type: 'success', text: '已經新增負項訂單。'
          });
          // this.dialog.detail.show = false;
        })
        .catch(err => {
          let errMsg = '發生錯誤，無法新增此負項訂單。';
          if (err.response && err.response.data && err.response.data.message) {
            errMsg = err.response.data.message;
          } 
          this.$notify({
            type: 'error', text: errMsg
          });
        })
        .finally(() => {
          this.closeDisputeDialog();
        });
      });
    }
  },

  data() {
    return {
      loading: false,

      order: { },
      transactions: [ ],

      showRequestContext: false,

      expansion: {
        detail: {
          show: false,
          context: { }
        }
      },
      dialog: {
        dispute : {
          show: false,
          model: {
            paymentOrderId: '',
            amount: 0,
            merchantId: '',
            reason: '爭議款'
          }
        }
      }
    }
  },

  computed: {
    transactionSchema() {
      return [
        { value: 'payment_order_id', text: this.$t('views.dialogOrderDetail.paymentOrderId') },
        { value: 'transaction_id', text: this.$t('views.dialogOrderDetail.transactionId') },
        { value: 'bank_transaction_id', text: this.$t('views.dialogOrderDetail.bankTransactionId') },
        { value: 'amount', text: '$' },
        { value: 'status', text: this.$t('views.dialogOrderDetail.status') },
        { value: 'status_code', text: this.$t('views.dialogOrderDetail.code') },
        { value: 'message', text: this.$t('views.dialogOrderDetail.message') },
        { value: 'created_at', text: this.$t('views.dialogOrderDetail.time') }
      ];
    },

    user() {
      return this.$store.getters.user;
    }
  },

  watch: {
    'paymentOrderId': {
      immediate: false,
      handler(id) {
        if (id && id.length) {
          this.fetchPaymentOrderInfo();
          this.fetchTransactionHistory();
        }
      }
    }
  }
}
</script>